// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"VRRatesCards_cardsContainer__BEpUX","defaultFigureCaption":"VRRatesCards_defaultFigureCaption__CLSuj","row":"VRRatesCards_row__JDJxZ"};